import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { inRoomDiningTagsSelector } from '../../../servicesSlice';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';

const ItemTagsList = (props) => {
  const { selectedItem } = props;
  const [loading, setLoading] = useState(true);
  const originalTags = useSelector(inRoomDiningTagsSelector);
  const [itemTags, setItemTags] = useState([]);

  useEffect(() => {
    const tempItemTags = originalTags.filter((item) => {
      return selectedItem?.tags?.includes(item.id);
    });
    setItemTags(tempItemTags);
    setLoading(false);
  }, [selectedItem, originalTags]);

  return (
    <>
      {loading ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : (
        <>
          <div className='row'>
            <div className='col-md-12'>
              <div className='details-label mb-2'>Tags</div>
              {itemTags?.length > 0 ? (
                itemTags.map((tag, index) => (
                  <div className='details-value' key={index}>
                    {tag.name}
                  </div>
                ))
              ) : (
                <div className='details-value'>---</div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ItemTagsList;
